import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPopups } from '../selectors';
import Header from './Header';
import MainSection from './MainSection';
import Overlay from '../components/Overlay';
import PSSupplierView from '../components/PSSupplierView';
import { reducers } from '../store/configurePSSupplierStore';
import withReducers from '../store/withReducers';

class PSSupplierApp extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { popups } = this.props;

        return (
            <div>
                <Header>
                    <div>
                        <div className="large-8 columns">
                            <h4 style={{ display: 'inline-block' }}>
                                <span>Promostandards</span>
                            </h4>
                        </div>
                    </div>
                </Header>
                <MainSection popups={popups}>
                    <PSSupplierView />
                </MainSection>
                <Overlay popups={popups} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    popups: getPopups(state),
});

export default withReducers(connect(mapStateToProps)(PSSupplierApp), reducers, true);
